module.exports = __webpack_public_path__ + "img/defalut.cbba87ab.png";